export const currentStudentSelector = (state: any) => state.currentStudent;
